<div class="app-shell">
  <router-outlet></router-outlet>
  <app-footer *ngIf="showFooter"></app-footer>
</div>
